import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import {Router} from "@angular/router"
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpErrorResponse} from '@angular/common/http';
import { MatDialog} from '@angular/material/dialog';
import { environment } from '../../../environments/environment';
import { DlgTrabajandoComponent } from '../../components/dlg-trabajando/dlg-trabajando.component';
import { DlgErrorComponent } from '../../components/dlg-error/dlg-error.component';
import {MatDialogRef} from '@angular/material/dialog';
import { DlgAvisoComponent } from '../../components/dlg-aviso/dlg-aviso.component';
import { DlgObrasSocialesPlanComponent } from '../../components/dlg-obras-sociales-plan/dlg-obras-sociales-plan.component';
import { MatPaginator} from '@angular/material/paginator'
import { MatTableDataSource} from '@angular/material/table'
import { funciones } from '../../funciones';
import {DlgObrasSocialesPrestacionComponent } from '../../components/dlg-obras-sociales-prestacion/dlg-obras-sociales-prestacion.component';

@Component({
  selector: 'app-dlg-obras-sociales',
  templateUrl: './dlg-obras-sociales.component.html',
  styleUrls: ['./dlg-obras-sociales.component.css']
})
export class DlgObrasSocialesComponent implements OnInit {

  titulo=""
  nombre=""
  habilitado=true
  idActual=""
  chkGravado=true;
  chkNoPlanes=true;
  planesOS: any[] = [];
  prestacionesPlanesOS: any[] = [];
  indicePlanActual=0;
  dataSourcePrestaciones = new MatTableDataSource();
  @ViewChild('paginador') paginador: MatPaginator;
  displayedColumnsPrestaciones = ['acciones','habilitado','frase'];
  tablaPrestacionesPlanActual: any[] = [];
  escondeFraseNoHayPrestaciones=false;
  @ViewChild('paginadorSoloDefecto') paginadorSoloDefecto: MatPaginator;

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private httpClient: HttpClient,
    @Inject(SESSION_STORAGE) private storage: StorageService,
    public thisDialogRef: MatDialogRef<DlgObrasSocialesComponent>,
  ) { }


  ngOnInit(): void {
    if (this.storage.get("idConexion")==null){
      this.router.navigate(['/'])
    }
    this.leerDato();
  }

  leerDato(){
    let dlgTrabajando = this.dialog.open(DlgTrabajandoComponent, {
      width: '600px',
      disableClose:true
    });
    dlgTrabajando.componentInstance.titulo="";
    dlgTrabajando.componentInstance.texto="Buscando los datos de la obra social";

    this.httpClient.get(environment.servidorHttp+'Sistema/leerObrasSocialesDato'
      ,{
        params: {
          "idConexion": this.storage.get("idConexion"),
          "idObraSocial": this.idActual,
        },
        headers:{
          "Authorization":'Bearer ' + this.storage.get("token"),
        }
      })
    .subscribe(data => {
      this.cerrarDialogo(dlgTrabajando);
      if (data['resultado']['msgError']['valorDevuelto']=="01"){
        let dlgError = this.dialog.open(DlgErrorComponent, {
          width: '600px',
          disableClose:true
        });
        dlgError.componentInstance.titulo="Error al buscar los datos de la obra social";
        dlgError.componentInstance.texto=data['resultado']['msgError']['mensaje'];
      } else{
        this.titulo=data['resultado']['msgError']['titulo'];
        if (data['resultado']['msgError']['nombre']!=null){
          this.nombre=data['resultado']['msgError']['nombre'];
          this.habilitado=data['resultado']['msgError']['habilitado']=="1";
          this.chkGravado=data['resultado']['msgError']['gravado']=="1";
          this.chkNoPlanes=data['resultado']['msgError']['noPlan']=="1";
        }
        if (data['resultado']['dtPlanes']!=null){
          this.planesOS=data['resultado']['dtPlanes'];
        }
        if (data['resultado']['dtPrestaciones']!=null){
          this.prestacionesPlanesOS=data['resultado']['dtPrestaciones'];
          this.cargaPrestacionesPlanActual();
        }
      }
    },
    (error: HttpErrorResponse) => {
      this.cerrarDialogo(dlgTrabajando);
      let dlgError = this.dialog.open(DlgErrorComponent, {
        width: '600px',
        disableClose:true
      });
      if (error.status.toString()=="401"){
        dlgError.componentInstance.titulo="Error al buscar los datos de la obra social";
        dlgError.componentInstance.texto="Su sesión ha finalizado";
        this.router.navigate(['/']);
      }else{
        dlgError.componentInstance.titulo="Error al buscar los datos de la obra social";
        dlgError.componentInstance.texto=error.message+" ("+error.status+")";
      }
    });
  }

  cerrarDialogo(dialogoActual) {
    dialogoActual.close();
  }

  cerrar(cadena) {
    this.thisDialogRef.close({mensaje: cadena});
  }

  modificarPlan(idPlan, nombrePlan, habilitado){
    let dlgOSMod = this.dialog.open(DlgObrasSocialesPlanComponent, {
      maxWidth: '95vw',
      maxHeight: '95vh',
      height: '50%',
      width: '60%',
      disableClose:true
    });
    var titulo='Modificar plan';
    if (idPlan=='00000000-0000-0000-0000-000000000000'){
      titulo='Agregar plan';
    }
    dlgOSMod.componentInstance.idActual=idPlan;
    dlgOSMod.componentInstance.titulo=titulo;
    dlgOSMod.componentInstance.nombre=nombrePlan;
    dlgOSMod.componentInstance.habilitado=habilitado;
    dlgOSMod.afterClosed().subscribe(
        data => {
          if (data.mensaje=="almaceno"){
            if (data.idPlan=="00000000-0000-0000-0000-000000000000"){
              if (this.planesOS.length==0){
                data.idPlan='00000000-0000-0000-0000-000000000001'
              }else{
                data.idPlan=funciones.newGuid();
              }
            }
            
            for (var i = 0; i < this.planesOS.length; i++) {
              if (this.planesOS[i]['idPlan']!=data.idPlan
                && this.planesOS[i]['nombre']==data.nombre){
                  let dlgError = this.dialog.open(DlgErrorComponent, {
                    width: '600px',
                    disableClose:true
                  });
                  dlgError.componentInstance.titulo="Error al modificar el plan";
                  dlgError.componentInstance.texto='El nombre del plan ya existe';
                  return;
              }              
            }

            var encontrado=false;
            for (var i = 0; i < this.planesOS.length; i++) {
              if (this.planesOS[i]['idPlan']==data.idPlan){
                this.planesOS[i]['nombre']=data.nombre;
                this.planesOS[i]['habilitado']=data.habilitado;
                encontrado=true;
              }
            }

            if (!encontrado){
              this.planesOS.push({'idPlan': data.idPlan
                , 'nombre': data.nombre
                , 'habilitado': data.habilitado
              });
            }
          }
        }
    );
  }

  modificarPrestacionPlan(idPlan, idPlanPrestacion, idPrestacion, prestacionActual, codigoPrestador, nombrePrestador
      ,habilitado, porPresupuesto, tipoCoseguro, coseguro, importeOS){
    if (idPlan=='00000000-0000-0000-0000-000000000001'
      || this.planesOS.length==0){
      if (this.planesOS.length==0){
        this.planesOS.push({'idPlan': '00000000-0000-0000-0000-000000000001'
          , 'nombre': 'Defecto'
          , 'habilitado': '1'
        });
      }else{
        var encontrado=false;
        for (var i = 0; i < this.planesOS.length; i++) {
          if (this.planesOS[i]['idPlan']==idPlan){
            encontrado=true;
          }
        }

        if (!encontrado){
          this.planesOS.push({'idPlan': '00000000-0000-0000-0000-000000000001'
            , 'nombre': 'Defecto'
            , 'habilitado': '1'
          });
        }
      }
    }

    let dlgMod = this.dialog.open(DlgObrasSocialesPrestacionComponent, {
      maxWidth: '95vw',
      maxHeight: '95vh',
      height: '90%',
      width: '90%',
      disableClose:true
    });
    var titulo='Modificar prestación';
    if (idPlanPrestacion=='00000000-0000-0000-0000-000000000000'){
      titulo='Agregar prestación';
    }
    dlgMod.componentInstance.titulo=titulo;
    dlgMod.componentInstance.idActual=idPlanPrestacion;
    dlgMod.componentInstance.idPrestacion=idPrestacion;
    dlgMod.componentInstance.lblPrestacionActual=prestacionActual;
    dlgMod.componentInstance.txtCodigoPrestador=codigoPrestador;
    dlgMod.componentInstance.txtNombrePrestador=nombrePrestador;
    dlgMod.componentInstance.chkHabilitada=(habilitado=="1");
    dlgMod.componentInstance.chkPorPresupuesto=(porPresupuesto=="1");
    dlgMod.componentInstance.tipoCoseguro=tipoCoseguro;
    dlgMod.componentInstance.txtImporteCoseguro=coseguro;
    dlgMod.componentInstance.txtImporteOS=importeOS;
    dlgMod.afterClosed().subscribe(
        data => {
          if (data.mensaje=="almaceno"){
            if (data.idPlanPrestacion=="00000000-0000-0000-0000-000000000000"){
              data.idPlanPrestacion=funciones.newGuid();
            }
            
            for (var i = 0; i < this.prestacionesPlanesOS.length; i++) {
              if (this.prestacionesPlanesOS[i]['idPlanPrestacion']!=data.idPlanPrestacion
                && this.prestacionesPlanesOS[i]['idPlan']==data.idPlan
                && this.prestacionesPlanesOS[i]['idPrestacion']==data.idPrestacion){
                  let dlgError = this.dialog.open(DlgErrorComponent, {
                    width: '600px',
                    disableClose:true
                  });
                  dlgError.componentInstance.titulo="Error al modificar la prestación";
                  dlgError.componentInstance.texto='La prestación ya existe';
                  return;
              }              
            }

            var encontrado=false;
            for (var i = 0; i < this.prestacionesPlanesOS.length; i++) {
              if (this.prestacionesPlanesOS[i]['idPlanPrestacion']==data.idPlanPrestacion){
                this.prestacionesPlanesOS[i]['idPrestacion']=data.idPrestacion;
                this.prestacionesPlanesOS[i]['prestacionActual']=data.prestacionActual;
                this.prestacionesPlanesOS[i]['codigoPrestador']=data.codigoPrestador;
                this.prestacionesPlanesOS[i]['nombrePrestador']=data.nombrePrestador;
                this.prestacionesPlanesOS[i]['habilitado']=data.habilitado;
                this.prestacionesPlanesOS[i]['porPresupuesto']=data.porPresupuesto;
                this.prestacionesPlanesOS[i]['tipoCoseguro']=data.tipoCoseguro;
                this.prestacionesPlanesOS[i]['coseguro']=data.coseguro;
                this.prestacionesPlanesOS[i]['importeOS']=data.importeOS;
                encontrado=true;
              }
            }

            if (!encontrado){
              this.prestacionesPlanesOS.push({'idPlan': idPlan
                , 'idPlanPrestacion': data.idPlanPrestacion
                , 'idPrestacion': data.idPrestacion
                , 'prestacionActual': data.prestacionActual
                , 'codigoPrestador': data.codigoPrestador
                , 'nombrePrestador': data.nombrePrestador
                , 'habilitado': data.habilitado
                , 'porPresupuesto': data.porPresupuesto
                , 'tipoCoseguro': data.tipoCoseguro
                , 'coseguro': data.coseguro
                , 'importeOS': data.importeOS
              });
            }

            this.cargaPrestacionesPlanActual();
          }
        }
    );
  }

  public buscarPrestaciones = (value: string) => {
    this.dataSourcePrestaciones.filter = value.trim().toLocaleLowerCase();
  }

  cambiaPlan($event) {
    this.indicePlanActual = $event.index;
    this.cargaPrestacionesPlanActual();
  }

  cargaPrestacionesPlanActual(){
    this.tablaPrestacionesPlanActual=[];
    for (var i = 0; i < this.prestacionesPlanesOS.length; i++) {
        if (this.planesOS[this.indicePlanActual]['idPlan']
          ==this.prestacionesPlanesOS[i]['idPlan']){
            var frase=this.prestacionesPlanesOS[i]['prestacionActual']+' [(Cod.: '
              +this.prestacionesPlanesOS[i]['codigoPrestador']+') - '+this.prestacionesPlanesOS[i]['nombrePrestador']
              +']';

            if (this.prestacionesPlanesOS[i]['porPresupuesto']=='1'){
              frase=frase+'. Por presupuesto'
            }else{
              frase=frase+'. El coseguro es de $'+this.prestacionesPlanesOS[i]['coseguro'];
              if (this.prestacionesPlanesOS[i]['tipoCoseguro']=='PUEDEMODIFICAR'){
                frase=frase+' (Se puede modificar al recepcionar)'
              }else{
                frase=frase+' (No se puede modificar al recepcionar)'
              }
              frase=frase+' y el importe para la OS es de $'+this.prestacionesPlanesOS[i]['importeOS']
            }
            this.tablaPrestacionesPlanActual.push({'idPlan':this.prestacionesPlanesOS[i]['idPlan']
              ,'idPlanPrestacion': this.prestacionesPlanesOS[i]['idPlanPrestacion']
              ,'idPrestacion': this.prestacionesPlanesOS[i]['idPrestacion']
              ,'prestacionActual': this.prestacionesPlanesOS[i]['prestacionActual']
              ,'codigoPrestador': this.prestacionesPlanesOS[i]['codigoPrestador']
              ,'nombrePrestador': this.prestacionesPlanesOS[i]['nombrePrestador']
              ,'habilitado': this.prestacionesPlanesOS[i]['habilitado']=='1'
              ,'porPresupuesto': this.prestacionesPlanesOS[i]['porPresupuesto']=='1'
              ,'tipoCoseguro': this.prestacionesPlanesOS[i]['tipoCoseguro']
              ,'coseguro': this.prestacionesPlanesOS[i]['coseguro']
              ,'importeOS': this.prestacionesPlanesOS[i]['importeOS']
              ,'frase': frase

          });
        }
    }
    this.muestraTablaPrestacionesPlan();
  }

  muestraTablaPrestacionesPlan(){
    if (this.tablaPrestacionesPlanActual.length == 0) {
      this.escondeFraseNoHayPrestaciones = false;
      return;
    } else {
      this.escondeFraseNoHayPrestaciones = true;
    }
    this.dataSourcePrestaciones = new MatTableDataSource<any>(this.tablaPrestacionesPlanActual);
    if (this.planesOS[this.indicePlanActual]['idPlan']=='00000000-0000-0000-0000-000000000001'
        && this.chkNoPlanes){
      this.dataSourcePrestaciones.paginator = this.paginadorSoloDefecto;
      this.paginadorSoloDefecto._intl.itemsPerPageLabel = 'Prestaciones por hoja';
      this.paginadorSoloDefecto._intl.nextPageLabel  = 'Proxima hoja';
      this.paginadorSoloDefecto._intl.previousPageLabel  = 'Hoja anterior';
      this.paginadorSoloDefecto._intl.lastPageLabel  = 'Última hoja';
      this.paginadorSoloDefecto._intl.firstPageLabel  = 'Primera hoja';
      this.paginadorSoloDefecto._intl.getRangeLabel = (page: number, pageSize: number, length: number) => {
        return 'De '+((page * pageSize) + 1) + ' a ' + ((page * pageSize) + pageSize) + ' de ' + length; 
      }
    } else {
      this.dataSourcePrestaciones.paginator = this.paginador;
      this.paginador._intl.itemsPerPageLabel = 'Prestaciones por hoja';
      this.paginador._intl.nextPageLabel  = 'Proxima hoja';
      this.paginador._intl.previousPageLabel  = 'Hoja anterior';
      this.paginador._intl.lastPageLabel  = 'Última hoja';
      this.paginador._intl.firstPageLabel  = 'Primera hoja';
      this.paginador._intl.getRangeLabel = (page: number, pageSize: number, length: number) => {
        return 'De '+((page * pageSize) + 1) + ' a ' + ((page * pageSize) + pageSize) + ' de ' + length; 
      }
    }
    
  }

  almacenar(){
    let dlgTrabajando = this.dialog.open(DlgTrabajandoComponent, {
      width: '600px',
      disableClose: true
    });
    dlgTrabajando.componentInstance.titulo = "";
    dlgTrabajando.componentInstance.texto = "Intentando almacenar la obra social";

    var formData: any = new FormData();
    formData.append('idConexion', this.storage.get("idConexion"));
    formData.append('idObraSocial', this.idActual);
    formData.append('nombre', this.nombre);
    formData.append('gravado', this.chkGravado);
    formData.append('habilitado', this.habilitado);
    formData.append('noPlanes', this.chkNoPlanes);
    formData.append('dtPlanes', JSON.stringify(this.planesOS));
    formData.append('dtPrestaciones', JSON.stringify(this.prestacionesPlanesOS));
    
    this.httpClient.post(environment.servidorHttp + 'Sistema/modificarObraSocial', formData,
      {
        headers: {
          "Authorization": "Bearer " + this.storage.get("token") 
        },
      })
      .subscribe(data => {
        this.cerrarDialogo(dlgTrabajando);
        if (data['resultado']['msgError']['valorDevuelto'] == "01") {
          let dlgError = this.dialog.open(DlgErrorComponent, {
            width: '600px',
            disableClose: true
          });
          dlgError.componentInstance.titulo = "Error al almacenar la obra social";
          dlgError.componentInstance.texto = data['resultado']['msgError']['mensaje'];
        } else if (data['resultado']['msgError']['valorDevuelto'] == "10") {
          let dlgError = this.dialog.open(DlgErrorComponent, {
            width: '600px',
            disableClose: true
          });
          dlgError.componentInstance.titulo = "Error al almacenar la obra social";
          dlgError.componentInstance.texto = data['resultado']['msgError']['mensaje'];
          this.router.navigate(['/']);
        } else {
          let dlgAviso = this.dialog.open(DlgAvisoComponent, {
            width: '600px',
            disableClose: true
          });
          dlgAviso.componentInstance.titulo = "Aviso del sistema";
          dlgAviso.componentInstance.texto = data['resultado']['msgError']['mensaje'];
          this.cerrar('almaceno');
        }
      },
        (error: HttpErrorResponse) => {
          this.cerrarDialogo(dlgTrabajando);
          let dlgError = this.dialog.open(DlgErrorComponent, {
            width: '600px',
            disableClose: true
          });
          if (error.status.toString() == "401") {
            dlgError.componentInstance.titulo = "Error al almacenar el dato de la obra social";
            dlgError.componentInstance.texto = "Su sesión ha finalizado";
            this.router.navigate(['/']);
          } else {
            dlgError.componentInstance.titulo = "Error al almacenar el dato de la obra social";
            dlgError.componentInstance.texto = error.message + " (" + error.status + ")";
          }
        }
      );
  }
}
